import { ENV } from "../utils";

export class Testimonios {
  baseApi = ENV.BASE_API;

  async getAll(soloActivos = false) {
    const url = `${this.baseApi}/${ENV.API_ROUTES.TESTIMONIOS}?activo=${soloActivos}`;
    const res = await fetch(url);
    const data = await res.json();
    if (res.status !== 200) throw data;
    return data;
  }

  async create(accessToken, body) {
    const res = await fetch(`${this.baseApi}/${ENV.API_ROUTES.TESTIMONIOS}`, {
      method: "POST",
      headers: { "Content-Type": "application/json", Authorization: `Bearer ${accessToken}` },
      body: JSON.stringify(body),
    });
    const data = await res.json();
    if (res.status !== 201) throw data;
    return data;
  }

  async update(accessToken, id, body) {
    const res = await fetch(`${this.baseApi}/${ENV.API_ROUTES.TESTIMONIOS}/${id}`, {
      method: "PATCH",
      headers: { "Content-Type": "application/json", Authorization: `Bearer ${accessToken}` },
      body: JSON.stringify(body),
    });
    const data = await res.json();
    if (res.status !== 200) throw data;
    return data;
  }

  async remove(accessToken, id) {
    const res = await fetch(`${this.baseApi}/${ENV.API_ROUTES.TESTIMONIOS}/${id}`, {
      method: "DELETE",
      headers: { Authorization: `Bearer ${accessToken}` },
    });
    const data = await res.json();
    if (res.status !== 200) throw data;
    return data;
  }
}
